import { Injectable, inject } from '@angular/core';
import { UserInfoProviderService } from '../providers/user-info-provider.service';
import { Permission } from '../enums/permission';
import { PermissionOperator } from '../enums/permission-operator';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly provider = inject(UserInfoProviderService);

  public hasPermission(permission: Permission): boolean {
    const permissions = this.provider.permissions();

    return permissions.includes(permission);
  }

  public hasMultiplePermissions(
    permissions: Permission[],
    operator: PermissionOperator = PermissionOperator.Or,
  ): boolean {
    if (this.isAndOperator(operator)) {
      return permissions.every((permission: Permission) =>
        this.hasPermission(permission),
      );
    }

    if (this.isOrOperator(operator)) {
      return permissions.some((permission: Permission) =>
        this.hasPermission(permission),
      );
    }

    return false;
  }

  private isOrOperator(operator: PermissionOperator): boolean {
    return [PermissionOperator.Or].includes(operator);
  }

  private isAndOperator(operator: PermissionOperator): boolean {
    return [PermissionOperator.And].includes(operator);
  }
}
